











import { Vue, Component } from 'vue-property-decorator';
import { getBaseInfo } from './api';
import BottomTabBar from '@/components/BottomTabbar.vue';
import { isWeiXin } from '@/common/ts/common';
@Component({
  components: {
    BottomTabBar,
  },
})
export default class ViewHolder extends Vue {
  baseInfo: any = {};
  tabs = [
    { tabName: '活动页面', tabPath: '/20210115GZLDZ/home' },
    { tabName: '活动简介', tabPath: '/20210115GZLDZ/info' },
    { tabName: '活动规则', tabPath: '/20210115GZLDZ/rules' },
    { tabName: '相关新闻', tabPath: '/20210115GZLDZ/news' },
  ];
  themeColor = { activeBgColor: 'rgb(138 18 19)', inactiveBgColor: '#FFFFFF' };
  async created() {
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    console.log('base info is:', ret);
    this.$addPv(this.baseInfo.activityId);
    this.$appShareInfo({
      title: '为川渝高质量点赞',
      url: location.href,
      subtitle: '2021年川渝消费品(服务)点赞展示活动',
      classId: -1,
      id: -1,
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '为川渝高质量点赞',
        subtitle: '2021年川渝消费品(服务)点赞展示活动',
        image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      });
    }
  }
}
